<div class="modal fade" id="unavailabilityModal" tabindex="-1" role="dialog" aria-labelledby="unavailabilityLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form (ngSubmit)="save()" novalidate>
        <div class="modal-header">
          <h5 class="modal-title" id="unavailabilityLabel">
            <span class="unavailability-swatch"></span>
            {{ readOnly ? 'Indisponibilité' : (editedId === null ? 'Nouvelle indisponibilité' : 'Modifier l\'indisponibilité') }}
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body">
          <div class="alert alert-danger py-2" *ngIf="error">{{ error }}</div>

          <fieldset [disabled]="readOnly">
            <div class="form-group">
              <label for="unavMonitor">Moniteur</label>
              <select id="unavMonitor" name="monitorId" class="form-control" [(ngModel)]="monitorId" [disabled]="monitors.length === 1 || readOnly">
                <option [ngValue]="null" disabled>Choisir un moniteur</option>
                <option *ngFor="let m of monitors" [ngValue]="m.id">{{ m.firstname }} {{ m.lastname }}</option>
              </select>
            </div>

            <div class="form-group">
              <label class="d-block">Durée</label>
              <div class="btn-group btn-group-sm w-100" role="group">
                <button type="button" class="btn" [ngClass]="mode === 'DAY' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="mode = 'DAY'">Journée</button>
                <button type="button" class="btn" [ngClass]="mode === 'PERIOD' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="mode = 'PERIOD'">Période</button>
                <button type="button" class="btn" [ngClass]="mode === 'SLOT' ? 'btn-secondary' : 'btn-outline-secondary'" (click)="mode = 'SLOT'">Créneau horaire</button>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group" [ngClass]="mode === 'PERIOD' ? 'col-6' : 'col-12'">
                <label for="unavDate">{{ mode === 'PERIOD' ? 'Du' : 'Date' }}</label>
                <input id="unavDate" name="date" type="date" class="form-control" [(ngModel)]="date" required>
              </div>
              <div class="form-group col-6" *ngIf="mode === 'PERIOD'">
                <label for="unavDateEnd">Au (inclus)</label>
                <input id="unavDateEnd" name="dateEnd" type="date" class="form-control" [(ngModel)]="dateEnd" [min]="date" required>
              </div>
            </div>

            <div class="form-row" *ngIf="mode === 'SLOT'">
              <div class="form-group col-6">
                <label for="unavHourStart">De</label>
                <select id="unavHourStart" name="hourStart" class="form-control" [(ngModel)]="hourStart">
                  <option *ngFor="let h of hours" [ngValue]="h">{{ h }}</option>
                </select>
              </div>
              <div class="form-group col-6">
                <label for="unavHourEnd">À</label>
                <select id="unavHourEnd" name="hourEnd" class="form-control" [(ngModel)]="hourEnd">
                  <option *ngFor="let h of hours" [ngValue]="h">{{ h }}</option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label for="unavReason">Motif</label>
              <select id="unavReason" name="reason" class="form-control" [(ngModel)]="reason">
                <option *ngFor="let r of reasons" [ngValue]="r.value">{{ r.label }}</option>
              </select>
            </div>

            <div class="form-group mb-0">
              <label for="unavComment">Commentaire (facultatif)</label>
              <input id="unavComment" name="comment" class="form-control" maxlength="255" [(ngModel)]="comment">
            </div>
          </fieldset>

          <small class="d-block text-muted mt-3" *ngIf="!readOnly">
            <i class="fa fa-info-circle"></i> Les créneaux libres du moniteur sur cette période seront supprimés.
            Les heures déjà réservées pour un élève doivent être déplacées avant.
          </small>
        </div>

        <div class="modal-footer">
          <ng-container *ngIf="!readOnly && editedId !== null">
            <button type="button" class="btn btn-outline-danger mr-auto" *ngIf="!confirmDelete" (click)="confirmDelete = true">Supprimer</button>
            <span class="mr-auto" *ngIf="confirmDelete">
              Confirmer ? <button type="button" class="btn btn-sm btn-danger" (click)="remove()">Oui, supprimer</button>
            </span>
          </ng-container>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ readOnly ? 'Fermer' : 'Annuler' }}</button>
          <button type="submit" class="btn btn-primary" *ngIf="!readOnly" [disabled]="saving">
            <span *ngIf="saving" class="spinner-border spinner-border-sm"></span> Enregistrer
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
